"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformForSelect = exports.transformDropdownOptions = exports.transformDisableSelectOption = exports.makeBold = void 0;

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line import/prefer-default-export
var makeBold = function makeBold(_ref) {
  var section = _ref.section,
      keyword = _ref.keyword,
      withBr = _ref.withBr;

  if (Array.isArray(keyword)) {
    var modifySection = null;
    keyword.map(function (text, i) {
      var re = new RegExp(text, 'g');

      if (!modifySection) {
        modifySection = section;
      }

      var br = withBr[i] ? '<br>' : '';
      var PBold = modifySection.replace(re, "\n        ".concat(br, "\n        <p class=\"inline font-bold\">").concat(text, "</p>"));
      modifySection = PBold;
      return PBold;
    });
    return modifySection;
  }

  var re = new RegExp(keyword, 'g');
  return section.replace(re, "<p class=\"inline font-bold\">".concat(keyword, "</p>"));
};

exports.makeBold = makeBold;

var transformDropdownOptions = function transformDropdownOptions(_ref2) {
  var _ref2$elements = _ref2.elements,
      elements = _ref2$elements === void 0 ? [] : _ref2$elements,
      _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? 'name' : _ref2$name,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? 'label' : _ref2$label,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? 'disabled' : _ref2$disabled,
      options = _ref2.options;
  return elements.map(function (element) {
    return _objectSpread(_objectSpread({}, element), {}, {
      name: element[name],
      label: element[label],
      disabled: element[disabled],
      options: element[options]
    });
  });
};

exports.transformDropdownOptions = transformDropdownOptions;

var getObjectProp = function getObjectProp(obj, prop) {
  return prop.split('.').reduce(function (r, e) {
    return r[e];
  }, obj);
};

var transformForSelect = function transformForSelect(elements, value, label) {
  var levels = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _levels$moreLevels = levels.moreLevels,
      moreLevels = _levels$moreLevels === void 0 ? false : _levels$moreLevels,
      _levels$levelsValuesK = levels.levelsValuesKey,
      levelsValuesKey = _levels$levelsValuesK === void 0 ? '' : _levels$levelsValuesK,
      _levels$levelsLabelsK = levels.levelsLabelsKey,
      levelsLabelsKey = _levels$levelsLabelsK === void 0 ? '' : _levels$levelsLabelsK;
  var selectElements = elements.map(function (element) {
    return _objectSpread(_objectSpread({}, element), {}, {
      value: moreLevels ? getObjectProp(element[value], levelsValuesKey) : element[value],
      label: moreLevels ? getObjectProp(element[label], levelsLabelsKey) : element[label]
    });
  });
  return selectElements;
};

exports.transformForSelect = transformForSelect;

var transformDisableSelectOption = function transformDisableSelectOption() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var optionToDisable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!optionToDisable) return options;
  var filteredOptions = options.map(function (option) {
    var sameField = option.uuid === optionToDisable;

    if ((0, _isArray2.default)(optionToDisable)) {
      var disabled = optionToDisable.map(function (current) {
        return (0, _isObject2.default)(current) ? current.uuid : current;
      }).includes(option.uuid);
      return _objectSpread(_objectSpread({}, option), {}, {
        disabled: disabled
      });
    }

    return _objectSpread(_objectSpread({}, option), {}, {
      disabled: sameField
    });
  });
  return filteredOptions;
};

exports.transformDisableSelectOption = transformDisableSelectOption;